import React from 'react';
import { Toast, ToastHeader, ToastBody } from 'reactstrap';

//Presentational component that displays a Toast message
function ToastMessage(props) {
  const {
    showToast,
    icon = 'dark',
    title = '',
    label = '',
    message = ''
  } = props;

  let bgString = 'rgba(246,246,246,1)';
  if (icon === 'success'){
    bgString = 'rgba(237, 245, 241, 1)'; //#edf5f1. #e8f3ee is 232,243,238 a light tint of BS alert (see choose-access-method page)
  }

  //style on Toast places the message in middle center of the view (the Bootstrap classes place it in middle center of the top of the page, even if that is hidden by scrolling)
  return(
    <Toast isOpen={showToast} fade={false} style={{ position: 'fixed', top: 0, left: '50%', transform: 'translateX(-50%)', zIndex: 9999, backgroundColor: `${bgString}`}} >
      <ToastHeader icon={icon} style={{ color: 'black'}}>
        {title}
      </ToastHeader>
      <ToastBody>
        <strong>{label}</strong> {message}
      </ToastBody>
    </Toast>
  );
}

export default ToastMessage;
